import React, { useState, useEffect, useRef } from "react";
import { FaEdit, FaDownload, FaExpand } from "react-icons/fa";
import DownloadImageModel from "./DownloadImageModel";
import History from "../History/History";
import { useImage } from "../../context/ImageContext";
import ImageModal from "./ImageModal";
import { lowQualityToHighQuality } from "../../config/aws";
const All_History = [
  {
    "product": "Table1",
    "style": "Chair",
    "creativeControl": "Moderate",
    "time": "15:33, Jan 25, 2025",
    "Prompt": "A wooden chair on a grassy lawn ",
    "images": [
      {
        src: "https://storage.googleapis.com/a1aa/image/j2UHfnDurRA0tHq8Iwp8biLrlAGqNMRcRPJXqpaWdVw.jpg",
        alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
      },
      {
        src: "https://storage.googleapis.com/a1aa/image/FzAnFBYrF2g6I2cw8ZW7O8sFF5VDbC07owOmDBvgFMU.jpg",
        alt: "A wooden chair on a grassy lawn",
      }
    ]
  },
];



const MainCreate = ({ editUploadedImages, setEditUploadedImages, allCreateHistory, allEditHistory, setAllEditHistory, createPageNumber, setCreatePageNumber, setCreditsAvailable, creditsAvailable }) => {
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const { activeTab, setActiveTab } = useImage();
  const containerRef = useRef(null);

  useEffect(() => {
    const loadHighQualityImages = async () => {
      if (allCreateHistory.length > 0) {
        const updatedImages = [...allCreateHistory[0].images];
        for (let i = 0; i < updatedImages.length; i++) {
          // console.log("in MainCreate useEffect allCreateHistory changed    fetching high quality images");
          updatedImages[i] = {
            ...updatedImages[i],
            src: await lowQualityToHighQuality(updatedImages[i].src)
          };
        }
        setSelectedGroup(updatedImages);
      }
    };
    
    loadHighQualityImages();
  }, [allCreateHistory]);

  useEffect(() => {
    selectedGroup.forEach(image => {
      if (image.src.includes("lowQuality")) {
        // console.log("in MainCreate useEffect selectedGroup changed    fetching high quality images");
        lowQualityToHighQuality(image.src).then(highQualityUrl => {
          image.src = highQualityUrl;
        });
      }
    });
  }, [selectedGroup]);

  return (
    <div className="overflow-y-auto h-full" style={{ maxHeight: '100vh' }} ref={containerRef}>
      <div className="flex-1 flex items-center justify-center p-2 sm:p-4 mt-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-4xl">
          {selectedGroup.map((image, index) => (
            <div
              key={index}
              className="relative group w-full sm:w-72 h-72 overflow-hidden rounded-xl shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />
              <img
                src={image.src}
                className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:rotate-1"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-500" />
              <div className="absolute top-2 right-2 sm:top-1 sm:right-1 flex gap-2 z-20 opacity-0 group-hover:opacity-100">
                <button
                  className="bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-lg hover:bg-gray-400 transition-all duration-300 transform hover:scale-110 hover:shadow-xl"
                  onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                >
                  <FaDownload className="text-white text-lg" />
                </button>
                <button
                  className="bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-lg hover:bg-gray-400 transition-all duration-300 transform hover:scale-110 hover:shadow-xl"
                  onClick={async () => {
                    setEditUploadedImages([{src: image.src, alt: "High Quality Image"}]);
                    setActiveTab('edit');
                    setAllEditHistory([{images: [{src: image.src, alt: "Image from Create History"}]}, ...allEditHistory]);
                  }}
                >
                  <FaEdit className="text-white text-lg" />
                </button>
                <button
                  className="bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-lg hover:bg-gray-400 transition-all duration-300 transform hover:scale-110 hover:shadow-xl"
                  onClick={() => setModalImage(image)}
                >
                  <FaExpand className="text-white text-lg" />
                </button>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 transform translate-y-full group-hover:translate-y-0 transition-transform duration-500 z-20">
                <p className="text-white text-sm font-medium line-clamp-2">{image.alt}</p>
              </div>
              {activeIndex === index && (
                <div className="absolute inset-0 flex items-center justify-center z-30">
                  <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setActiveIndex(null)} />
                  <DownloadImageModel onClose={() => setActiveIndex(null)} imageData={image}  creditsAvailable={creditsAvailable} setCreditsAvailable={setCreditsAvailable}/>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <History
        All_History={allCreateHistory} 
        setSelectedGroup={setSelectedGroup}
        setModalImage={setModalImage}
        setEditUploadedImages={setEditUploadedImages}
        setActiveTab={setActiveTab}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        createPageNumber={createPageNumber}
        setCreatePageNumber={setCreatePageNumber}
        containerRef={containerRef}
        allEditHistory={allEditHistory}
        setAllEditHistory={setAllEditHistory}
        activeTab={activeTab}
      />
      {modalImage && (
        <ImageModal
          image={modalImage}
          onClose={() => setModalImage(null)}
        />
      )}
    </div>
  );
};

export default MainCreate;